import React from "react";
const InputField = ({ label, labelClasses, name, type = "text", value, onChange, placeholder = "", error = "", extraClasses = "", icon = null }) => {
  const borderClass = error ? "!border-red-500" : "border-gray-300";
  return (
    <>
      {label && <label className={`block text-sm font-medium mb-2 ${labelClasses} text-gray-900`}>{label}</label>}
      <div className="relative">
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`w-full bg-white rounded px-4 placeholder:text-[#33333369] focus:ring-orange-600 focus:border-orange-600 ${borderClass} ${extraClasses} ${
            icon ? "pr-10" : ""
          }`}
        />
        {icon && <div className="absolute inset-y-0 right-3 flex items-center">{icon}</div>}
      </div>
      {error && <p className="text-sm text-red-500 mt-1">{error}</p>}
    </>
  );
};
export default InputField;
